import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Products from '@/views/Products.vue';
import ProductDetail from '@/views/ProductDetail.vue';
import News from '@/views/News.vue';
import NewsDetail from '@/views/NewsDetail.vue';
import Contact from '@/views/Contact.vue';
import FAQ from '@/views/FAQ.vue';
import UserGuide from '@/views/UserGuide.vue';
import Careers from '@/views/Careers.vue';
import Privacy from '@/views/Privacy.vue';
import Returns from '@/views/Returns.vue';
import Shipping from '@/views/Shipping.vue';

export const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/products',
    name: 'products',
    component: Products
  },
  {
    path: '/products/:id',
    name: 'product-detail',
    component: ProductDetail
  },
  {    path: '/news',
    name: 'news',
    component: News
  },
  {    path: '/news/:id',
    name: 'news-detail',
    component: NewsDetail
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQ
  },
  {
    path: '/careers',
    name: 'careers',
    component: Careers
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/returns',
    name: 'returns',
    component: Returns
  },
  {
    path: '/shipping',
    name: 'shipping',
    component: Shipping
  },
  {
    path: '/user-guide',
    name: 'user-guide',
    component: UserGuide
  }
];

export const createAppRouter = () => {
  const isBrowser = typeof window !== 'undefined';
  const base = import.meta.env.BASE_URL||"/"; // 使用环境变量中的基础路径
  
  const history = createWebHistory(base);

  return createRouter({
    history,
    routes,
    scrollBehavior(_to, _from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { top: 0 };
      }
    }
  });
};

export default createAppRouter;
